import { FC } from "react";
import { useTranslation } from "react-i18next";
import Modal from "Components/UI/Modal";
import Button from "Components/UI/Button";
import { Buttons, FooterHr, Wrapper } from "./styles";

interface ILimitsInfo {
  visible: boolean;
  isExtensionLimit?: boolean;
  onCancel: () => void;
}

const LimitsInfo: FC<ILimitsInfo> = ({
  visible,
  isExtensionLimit,
  onCancel,
}) => {
  const { t } = useTranslation(['sharedModals', 'common']);
  const footerConfirmButtons = (
    <Buttons>
      <Button
        onClick={onCancel}
        type="text"
        className="buttonCancel"
      >
        {t('common:close')}
      </Button>
    </Buttons>
  );

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footerButtons={footerConfirmButtons}
      footerActive={false}
      width={350}
      customClassName
    >
      <Wrapper>
        <div className="titleContent">
          <span className="title">
            {isExtensionLimit
              ? t('sharedModals:limitsInfo.extensionTitle')
              : t('sharedModals:limitsInfo.sizeTitle')
            }
          </span>
        </div>
        <hr className="midleHr"/>
        <div className="descriptionContent">
          <span className="description">
            {isExtensionLimit
              ? t('sharedModals:limitsInfo.extensionDesc1')
              : t('sharedModals:limitsInfo.sizeDesc1')
            }
          </span>
          <span className="description">
            {isExtensionLimit
              ? t('sharedModals:limitsInfo.extensionDesc2')
              : t('sharedModals:limitsInfo.sizeDesc2')
            }
          </span>
        </div>
      </Wrapper>
      <FooterHr />
    </Modal>
  )
}

export default LimitsInfo;
